// extracted by mini-css-extract-plugin
export default {"paymentInfo":"Gf79e81","row":"Gb61d87","bold":"G0d84e9","green":"G725fe0","separationBelow":"G05c36d"};